import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import { createViewAction } from "../../utils/helpers";
import { URL_FRAUD_TEMPLATES } from "../../utils/urls";

const url = URL_FRAUD_TEMPLATES;

export const useFraudTemplates = () => {
  const tableColumns = () => [
    { id: "code", header: "cODE", filter: { type: "text" } },
    { id: "category", header: "Category", filter: { type: "text" } },
    { id: "name", header: "name", filter: { type: "text" } },
    {
      id: "description",
      header: "Description",
      filter: { type: "text" },
    },
    { id: "is_active", header: "Is Active", filter: { type: "text" } },
    { id: "version", header: "Version" },
    { id: "created_by", header: "Created By", filter: { type: "text" } },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        code: item?.code,
        category: item?.category,
        name: item?.name,
        description: item?.description,
        version: item?.version,
        created_by:
          item?.created_by?.first_name + " " + item?.created_by?.last_name,
        is_active: <BooleanTags status={item?.is_active} />,
        actions: <FormActions actions={[createViewAction(url, item?.id)]} />,
      };
    }),
  ];

  const viewData = (item: any) => {
    if (!item) {
      return {
        sections: [
          {
            title: "Error",
            fields: {
              message: "No data available",
            },
          },
        ],
      };
    }
    return {
      sections: [
        {
          title: "Fraud Templates Details",
          fields: {
            code: item?.code,
            category: item?.category,
            name: item?.name,
            description: item?.description,
            version: item?.version,
            config_count: item?.config_count,
            is_active: <BooleanTags status={item?.is_active} />,
            parameters: item?.parameters?.map((param: any, index: number) => (
              <ul key={param.id || index}>
                {Object.entries(param)
                  .filter(([key]) => key !== "created_by") // exclude created_by
                  .map(([key, value]) => (
                    <li key={key}>
                      <strong>{key}:</strong> {String(value)}
                    </li>
                  ))}
              </ul>
            )),

            schema: Object.entries(item?.schema || {})
              .filter(([key]) => key !== "created_by")
              .map(([key, value]: [string, any], index: number) => (
                <ul key={index}>
                  <li>
                    <strong>{key}:</strong>{" "}
                    {typeof value === "object"
                      ? JSON.stringify(value)
                      : String(value)}
                  </li>
                </ul>
              )),
            created_by:
              item?.created_by?.first_name + " " + item?.created_by?.last_name,
          },
        },
      ],
    };
  };

  return {
    tableColumns,
    tableData,
    viewData,
  };
};
